<template>
  <div>
    <div class="package-orders-stage">
      <div class="row">
        <!-- Title -->
        <div class="stage-title">Zamówienia pakietowe</div>
        <hr />
      </div>

      <PackagesManagerOrdersRealisationView :orderGroupGuid="currentOrderGroupGuid"/>


    </div>
  </div>
</template>

<script>

import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import PackagesManagerOrdersRealisationView from "@/views/PackagesManager/PackagesManagerOrdersRealisationView.vue";

export default {
  name: "PackagesManagerOrdersRealisationLevelStage",
  components: {
    PackagesManagerOrdersRealisationView,
    },
  props: {
    orderGroupGuid: {
      type: String,
      required: false,
    },
  },
  data(){
    return {
      currentOrderGroupGuid: null,
      currentDrugstoreClientId: null,
    };
  },
  computed: {
    packagesModule(){
      return usePackagesManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

  },
  watch: {
  },
  created() {
    this.simplepharmAuth.refreshToken().then(()=>{
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    })
    if(this.orderGroupGuid && this.orderGroupGuid.length > 0) {
      this.currentOrderGroupGuid = this.orderGroupGuid;
    } else {
      this.currentOrderGroupGuid = this.$route.query.orderGroupGuid;
    }



  },
};
</script>

<style scoped>
.package-orders-stage {
  height: 1920px;
  background: #fafafa;
  margin-left: 16px;
  margin-right: 16px;

}
</style>
